import axios from "fetch-api/fetch-api";

export function getYearByMake(make: string) {
  return axios.get<string[]>("/get-years-by-make-v3", {
    params: {
      make,
    },
  });
}
